import clsx from 'clsx'

import { AdminButton } from './AdminButton'

type Props = {
  onCancel: () => void
  submitText?: string
  cancelText?: string
  className?: string
  loading?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const AdminFormActions = ({
  onCancel,
  submitText = 'Save',
  cancelText = 'Cancel',
  loading,
  size = 'md',
  className,
}: Props) => {
  const btnSize = clsx({
    'btn-sm': size === 'sm',
    'btn-md': size === 'md',
    'btn-lg': size === 'lg',
  })
  return (
    <div
      className={clsx('flex gap-2', className, {
        'justify-end': !className?.includes('justify-'),
      })}
    >
      {!!onCancel && (
        <AdminButton
          className={clsx('btn-error', btnSize)}
          onClick={onCancel}
          loading={loading}
        >
          {cancelText}
        </AdminButton>
      )}
      <AdminButton
        className={clsx('btn-primary', btnSize)}
        type="submit"
        loading={loading}
      >
        {submitText}
      </AdminButton>
    </div>
  )
}
